// definir un objeto mixin
var MpVideoModal = {
    data: function() {
        return {
            MODAL_VIDEO_PATH: '/videos/id/',

            currentVideo: '',
            videoContentHTML: '',

            isVideoShown: false,
        };
    },
    computed: {
        getVideoSrc: function() {
            return '/videos/id/'+this.currentVideo;
        }
    },
    methods: {

        showVideo: function(videoID) {
            this.currentVideo = videoID;
            this.getVideoContentHTML();
            this.isVideoShown  = true;
        },

        closeVideoModal: function() {
            this.isVideoShown = false;
            return;
        },

        onVideoContentHTMLLoaded: function(response) {
            var _ref = this;

            if (response.status !== 200) {
                return;
            }

            this.videoContentHTML = response.data;
            Vue.nextTick(function() {
                var videoPlayer = _ref.$el.querySelector('.js-video-player');
            videoPlayer.src = videoPlayer.getAttribute('data-src');
            });
        },

        getVideoContentHTML: function() {

            if (!CookieManager.isTypeAllowed(CookieManager.TYPE_MARKETING)) {
                console.warn('iframe video content blocked because cookie level acceptance.');
                return;
            }

            axios
                .post(this.getVideoSrc)
                .then(this.onVideoContentHTMLLoaded)
                .catch(function(error) {
                    console.log(error);
                });
        },
    },
    created: function() {
        MpEventBus.$on(EVENT_VIDEO_SHOW, this.showVideo);
    },
    destroyed: function() {
        MpEventBus.$off(EVENT_VIDEO_SHOW, this.showVideo);
    }
};
